import animation from './_animation';
import smoothScroll from './_smoothScroll';

const common = (): void => {
  // smooth scroll
  smoothScroll();
  animation();
};

export default common;
